import { message, Button, } from 'antd';
import React, { Component } from 'react';
import { createBrowserHistory } from "history";
import './pages.scss';

class Pages extends Component {
  state = {
    key: 0,
    menuType: [],
    userInfo: {}, //IS_ADMINISTRATOR
  }

  componentDidMount() {
		message.destroy();
    window.localStorage.removeItem(localStorage.getItem('menuList'))
    this.setState({
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      menuType: JSON.parse(localStorage.getItem('menuList'))
    })
  }

  handleCount() {
    window.open(window.g.viewURL)
  }

  handleClick(index, lurl, applyTabskey) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const roleList = JSON.parse(localStorage.getItem('roleList')) || {};
    const menuType = JSON.parse(localStorage.getItem('menuList')) || [];
    const custService = JSON.parse(localStorage.getItem('QUERY_ALL'));
    if (userInfo) {
      if (lurl === '') {
        message.warning("暂无权限，请联系管理员！")
        return
      }
      else {
        // 客服权限直接跳转远程申请
        if ((custService === 1 && lurl === 'dtxd') || (custService === 1 && lurl === 'jxxd') || (custService === 1 && lurl === 'dtxy')) {
          this.props.history.push('/siderPage?key=2&applyTabskey=' + applyTabskey)
        } else if (lurl === 'dtxd') {
          menuType.indexOf("动态心电") > -1 || userInfo.IS_ADMINISTRATOR ?
            (menuType.indexOf("远程申请") > -1 ? this.props.history.push('/siderPage?key=2&applyTabskey=' + applyTabskey)
              : (menuType.indexOf("远程会诊") > -1 ? this.props.history.push('/siderPage?key=6&applyTabskey=' + applyTabskey)
                : message.warning("暂无权限，请联系管理员！"))
            )
            : (message.warning("暂无权限，请联系管理员！"))
        }
        else if (lurl === 'jxxd') {
          menuType.indexOf("静息心电") > -1 || userInfo.IS_ADMINISTRATOR ?
            (menuType.indexOf("远程申请") > -1 ? this.props.history.push('/siderPage?key=2&applyTabskey=' + applyTabskey)
              : (menuType.indexOf("远程会诊") > -1 ? this.props.history.push('/siderPage?key=6&applyTabskey=' + applyTabskey)
                : message.warning("暂无权限，请联系管理员！"))
            )
            : (message.warning("暂无权限，请联系管理员！"))
        }
        else if (lurl === 'dtxy') {
          menuType.indexOf("动态血压") > -1 || userInfo.IS_ADMINISTRATOR ?
            (menuType.indexOf("远程申请") > -1 ? this.props.history.push('/siderPage?key=2&applyTabskey=' + applyTabskey)
              : (menuType.indexOf("远程会诊") > -1 ? this.props.history.push('/siderPage?key=6&applyTabskey=' + applyTabskey)
                : message.warning("暂无权限，请联系管理员！"))
            )
            : (message.warning("暂无权限，请联系管理员！"))
        }
        else if (lurl === 'dsjzs') {//特殊情况特殊处理
          menuType.indexOf("大数据展示") > -1 || userInfo.IS_ADMINISTRATOR ?
            window.open(window.g.viewURL)
            : message.warning("暂无权限，请联系管理员！")
        }
        else {
          custService === 1 || menuType.indexOf(index) > -1 || roleList.indexOf("二级管理员") > -1 || userInfo.IS_ADMINISTRATOR ? this.props.history.push(lurl) : message.warning("暂无权限，请联系管理员！")
        }
      }
    }
    else {
      this.props.history.push('/login')
    }
  }

  handleHospitalType() {
    const history = createBrowserHistory()
    const menuType = JSON.parse(localStorage.getItem('menuList')) || []

    if (menuType.indexOf("远程申请") > -1) {
      history.push({ pathname: "/siderPage", state: { key: 2 } });
    }
    if (menuType.indexOf("远程会诊") > -1) {
      history.push({ pathname: "/siderPage", state: { key: 6 } });
    }
  }
  downloadFile = () => {
    window.location.href = window.g.videoURL;
  }

  render() {
    const Token = window.localStorage.getItem('token')
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const menuType = JSON.parse(localStorage.getItem('menuList')) || [];
    const roleList = JSON.parse(localStorage.getItem('roleList')) || {};
    const custService = JSON.parse(localStorage.getItem('QUERY_ALL'));
    if (Token) {
      return (
        <div style={{ height: '100%' }} className="bgWrap">
          <div className="pagePic">
            <img alt="" className="logo" src={require("@/assets/image/zhu.png").default} />
          </div>

          <div className="menuPic">
            <div className="menuRight">
              <div className="menuSecound two">
                <div className='MSTtwo'>
                  <div className='f'>
                    <img alt="" className={custService === 1 ? '' : (menuType.indexOf("静息心电") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('静息心电', 'jxxd', 1)} style={{ marginLeft: '1.2%' }} src={require("@/assets/image/wjxxd.png").default} />
                    <img alt="" className={custService === 1 ? '' : (menuType.indexOf("动态心电") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('动态心电', 'dtxd', 2)} src={require("@/assets/image/wdtxd.png").default} />
                    <img alt="" className={custService === 1 ? '' : (menuType.indexOf("动态血压") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('动态血压', 'dtxy', 3)} src={require("@/assets/image/wdtxy.png").default} />
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("典型病例") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('典型病例', custService === 1 ? '' : '/siderPage?key=7')} src={require("@/assets/image/wdxbl.png").default} />
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("单向转诊") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('单向转诊', custService === 1 ? '' : '/siderPage?key=8')} style={{ marginRight: '1%', width: '24.6%' }} src={require("@/assets/image/hzzz.png").default} />
                  </div>
                  <div className='ftwo'>
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("数据统计") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('数据统计', custService === 1 ? '' : '/siderPage?key=12')} style={{ marginLeft: '0px' }} src={require("@/assets/image/wsjtj.png").default} />
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("质量控制") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('质量控制', custService === 1 ? '' : '/siderPage?key=15')} style={{ width: '24.5%' }} src={require("@/assets/image/wzlkz.png").default} />
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('危急病例', '')} src={require("@/assets/image/wwjbl.png").default} />
                    <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('远程教育', '')} style={{ width: '17%' }} src={require("@/assets/image/wycjy.png").default} />
                  </div>
                </div>
                <div className='MSTthree'>
                  <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("大数据展示") > -1) || userInfo.IS_ADMINISTRATOR ? '' : 'grey'} onClick={() => this.handleClick('大数据展示', custService === 1 ? '' : 'dsjzs')} style={{ marginRight: '1%' }} src={require("@/assets/image/wdsjzs.png").default} />
                </div>
              </div>
              <div className={custService === 1 ? 'menuSecound one' : (menuType.indexOf("展会模式") > -1) ? 'menuSecound one1' : 'menuSecound one'}>
                <div className='MSOne'>
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('预约登记', '')} src={require("@/assets/image/nyydj.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('电子叫号', '')} src={require("@/assets/image/ndzjh.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('数据统计', '')} src={require("@/assets/image/nsjtj.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('危急病例', '')} style={{ marginRight: '1%' }} src={require("@/assets/image/nwjbl.png").default} />
                </div>
                <div className='MSTwo'>
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('静息心电', '')} style={{ marginLeft: '1%' }} src={require("@/assets/image/njxxd.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('动态心电', '')} src={require("@/assets/image/ndtxd.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('动态血压', '')} src={require("@/assets/image/ndtxy.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('典型病例', '')} src={require("@/assets/image/ndxbl.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('实时监测', '')} style={{ width: '20.6%' }} src={require("@/assets/image/nssjc.png").default} />
                  <img alt="" className={(menuType.indexOf("展会模式") > -1) ? '' : "grey"} onClick={() => this.handleClick('质量控制', '')} style={{ marginRight: '1%' }} src={require("@/assets/image/nzlkz.png").default} />
                </div>
              </div>
            </div>
            <div className='menuRightr'>
              <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("综合查询") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('综合查询', custService === 1 ? '' : '/siderPage?key=16')} src={require("@/assets/image/nwzhcx.png").default} />
              <img alt="" className={custService === 1 ? 'grey' : (menuType.indexOf("系统配置") > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('系统配置', custService === 1 ? '' : '/siderPage?key=14')} src={require("@/assets/image/nwxtsz.png").default} />
              <img alt="" className={custService === 1 ? 'grey' : (roleList.indexOf('二级管理员') > -1) || userInfo.IS_ADMINISTRATOR ? '' : "grey"} onClick={() => this.handleClick('权限管理', custService === 1 ? 'qxgl' : '/siderPage?key=13')} src={require("@/assets/image/nwqxgl.png").default} />
            </div>
          </div>
          <div className="pageInfo">
            <p>&nbsp;&nbsp;&nbsp;系统操作视频&nbsp;&nbsp;
              <Button onClick={this.downloadFile} shape="round" className='downloadSytle'>
                <img alt="" style={{ width: '25px' }} src={require("@/assets/image/downLoad.png").default} />
                &nbsp;&nbsp;下载
              </Button>
            </p>
            <p></p>
            <p></p>
            <p></p>
            <p>版权所有：北京蓬阳健康科技股份有限公司</p>
            <p>技术支持：北京蓬阳健康科技股份有限公司</p>
            <p>服务热线：400 008 5809</p>
            <p></p>
            <p>Ver&nbsp;:&nbsp;{window.g.version}&nbsp;/&nbsp;{localStorage.getItem("VERSION")}&nbsp;&nbsp;&nbsp;</p>
          </div>
        </div >
      );
    }
  }
}

export default Pages;